module.exports = __webpack_public_path__ + "img/expert_personal_1280.d082108c.png";